import type { QuizPlayerScore } from '@mentimeter/quiz-types';

interface GroupedAnswer {
  identifiers: string[];
  answer: string;
  markedCorrect: boolean;
  markedInappropriate: boolean;
}

export const normalizeAnswer = (answer: string) => {
  return answer
    .toLowerCase()
    .trim() // Removes whitespace from both sides
    .replace(/\s+/g, ' '); // Replace spaces with ' '
};

export const groupAnswers = (scores: QuizPlayerScore[]): GroupedAnswer[] => {
  const groupByAnswers = scores.reduce<Record<string, GroupedAnswer>>(
    (acc, s) => {
      if (!s.score.question?.answer) return acc;
      if (s.score.question.isProfanity) return acc;

      const identifier = s.player.identifier;
      const { answer, markedCorrect, markedInappropriate } = s.score.question;
      const normalizedAnswer = normalizeAnswer(answer);

      const existingIdentifiers = acc[normalizedAnswer]?.identifiers ?? [];
      const existingAnswer = acc[normalizedAnswer]?.answer ?? answer;
      return {
        ...acc,
        [normalizedAnswer]: {
          answer: existingAnswer.trim(),
          identifiers: [...existingIdentifiers, identifier],
          markedCorrect: !!markedCorrect,
          markedInappropriate: !!markedInappropriate,
        },
      };
    },
    {},
  );
  return Object.values(groupByAnswers).sort(
    (a, b) => b.identifiers.length - a.identifiers.length,
  );
};
